import React from "react";
import PropTypes from "prop-types";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton
} from "react-share";

const ShareButtons = props => {
  const { theme, iconSize, postUrl, postTitle, postExcerpt, postCover } = props;

  return (
    <React.Fragment>
      <ul className="sharebuttons">
        <li>
          <TwitterShareButton
            url={postUrl}
            title={postTitle}
            additionalProps={{
              "aria-label": "Twitter share"
            }}
          >
            <TwitterIcon round size={iconSize} />
          </TwitterShareButton>
        </li>
        <li>
          <FacebookShareButton
            url={postUrl}
            quote={`${postTitle} - ${postExcerpt}`}
            additionalProps={{
              "aria-label": "Facebook share"
            }}
          >
            <FacebookIcon round size={iconSize} />
          </FacebookShareButton>
        </li>
        <li>
          <LinkedinShareButton
            url={postUrl}
            title={postTitle}
            additionalProps={{
              "aria-label": "Linkedin share"
            }}
          >
            <LinkedinIcon round size={iconSize} />
          </LinkedinShareButton>
        </li>

        <li>
          <RedditShareButton
            url={postUrl}
            title={postTitle}
            additionalProps={{
              "aria-label": "Reddit share"
            }}
          >
            <RedditIcon round size={iconSize} />
          </RedditShareButton>
        </li>
        <li>
          <PinterestShareButton
            url={postUrl}
            title={postTitle}
            media={postCover.desktop}
            additionalProps={{
              "aria-label": "Pinterest share"
            }}
          >
            <PinterestIcon round size={iconSize} />
          </PinterestShareButton>
        </li>
        <li>
          <EmailShareButton
            url={postUrl}
            title={postTitle}
            additionalProps={{
              "aria-label": "Email share"
            }}
          >
            <EmailIcon round size={iconSize} />
          </EmailShareButton>
        </li>
      </ul>
      {/* --- STYLES --- */}
      {/*language=SCSS*/}
      <style jsx>{`
        ul {
          float: right;
          list-style: none;
          margin: 23px 15px 0 0;

          li {
            float: left;
            margin-right: 10px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

ShareButtons.propTypes = {
  theme: PropTypes.object.isRequired,
  iconSize: PropTypes.number.isRequired,
  postUrl: PropTypes.string.isRequired,
  postTitle: PropTypes.string.isRequired,
  postExcerpt: PropTypes.string.isRequired,
  postCover: PropTypes.object.isRequired
};

export default ShareButtons;
